import { parse, format, isValid } from 'date-fns';

const CANDIDATES = ['yyyy-MM', 'yyyy/M', 'yyyyMM'] as const;

/** "YYYY-MM" 等を "YYYY/MM" に整形。合わない形式は元の文字列を返す */
export const formatYmDisplay = (input?: string | null) => {
  if (!input) return '';
  for (const pat of CANDIDATES) {
    const d = parse(input, pat, new Date());
    if (isValid(d)) return format(d, 'yyyy/MM');
  }
  return input;
};
